import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  collection,
  collectionSnapshots,
  Firestore,
} from '@angular/fire/firestore';
import { Guide, GuideClass } from '@sleipai/sleip-models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GuideService {
  constructor() {}

  private firestore = inject(Firestore);
  private destroyRef = inject(DestroyRef);

  loadGuides(): Observable<Guide[]> {
    const guidesRef = collection(this.firestore, 'guides');
    return collectionSnapshots(guidesRef).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((guideList) =>
        guideList.map(
          (event) =>
            new GuideClass({
              id: event.id,
              ...event.data(),
            })
        )
      )
    );
  }
}
